import { render } from "./TileInfoGrid.vue?vue&type=template&id=6e87fce5"
import script from "./TileInfoGrid.vue?vue&type=script&lang=ts"
export * from "./TileInfoGrid.vue?vue&type=script&lang=ts"
script.render = render

export default script